export default __webpack_public_path__ + "static/media/KidcoGrillGuide2.ae4b7f09.jpg";